import { render, staticRenderFns } from "./LeisurewearUpdateNew.vue?vue&type=template&id=1f4a7d9e"
import script from "./LeisurewearUpdateNew.vue?vue&type=script&lang=js"
export * from "./LeisurewearUpdateNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports